import { Link, useNavigate } from "react-router-dom";
import {
  SvgIdentificate,
  SvgSalir,
  SvgEditarUsuario,
  SvgFactura,
  SvgCorreo,
  SvgQuienesSomos,
  SvgSuscripcion,
  SvgGanancias,
} from "@/icons";
import TooltipLogBlock from "@/tooltip/TooltipLogBlock";
import { ButtonIconos } from "../../ui";
import { useAuthToken } from "../../../hooks/useAuthToken";
import EligeEmpresa from "../logBlock/EligeEmpresa";

interface MobileLogBlockProps {
  className?: string;
  onClose?: () => void;
}

const MobileLogBlock: React.FC<MobileLogBlockProps> = ({
  className = '',
  onClose
}) => {
  const navigate = useNavigate();
  const { token, roles, clearToken } = useAuthToken();

  // 🔥 NORMALIZACIÓN MULTI-ROL REAL
  const normalizedRoles = (roles || []).map(r =>
    r
      .replace(/^role_/i, "")
      .replace(/^role/i, "")
      .trim()
      .toLowerCase()
  );

  const isAdmin =
    normalizedRoles.includes("admin") ||
    normalizedRoles.includes("superadmin");

  const isProfesional = normalizedRoles.includes("profesional");
  const isAfiliado = normalizedRoles.includes("afiliado");
  const isUsuario = normalizedRoles.includes("usuario");
  const canSeeSuscripcion = isProfesional || isUsuario || isAdmin;

  const handleLogout = () => {
    clearToken();
    onClose?.();
    setTimeout(() => navigate("/"), 300);
  };

  return (
    <div className={`flex flex-col items-center w-16 space-y-4 p-4 ${className}`}>

      {/* 🔓 NO LOGUEADO */}
      {!token ? (
        <>
          <Link to="/sign" onClick={onClose}>
            <TooltipLogBlock label="Entrar" place="left">
              <ButtonIconos><SvgIdentificate /></ButtonIconos>
            </TooltipLogBlock>
          </Link>

          <Link to="/suscribirse" onClick={onClose}>
            <TooltipLogBlock label="Suscripción profesional" place="left">
              <ButtonIconos><SvgSuscripcion /></ButtonIconos>
            </TooltipLogBlock>
          </Link>

          <Link to="/contacto" onClick={onClose}>
            <TooltipLogBlock label="Soporte" place="left">
              <ButtonIconos><SvgCorreo /></ButtonIconos>
            </TooltipLogBlock>
          </Link>

          <Link to="/sobreNosotros" onClick={onClose}>
            <TooltipLogBlock label="Sobre nosotros" place="left">
              <ButtonIconos><SvgQuienesSomos /></ButtonIconos>
            </TooltipLogBlock>
          </Link>
        </>
      ) : (
        <>
          {/* 🔵 ADMIN */}
          {isAdmin && (
            <>
              <Link to="/" onClick={onClose}>
                <TooltipLogBlock label="Inicio" place="left" >
                  <ButtonIconos>
                    <SvgIdentificate className="text-green-400" />
                  </ButtonIconos>
                </TooltipLogBlock>
              </Link>

              <Link to="/backoffice" onClick={onClose}>
                <TooltipLogBlock label="Backoffice" place="left">
                  <ButtonIconos>
                    <SvgIdentificate className="text-blue-400 rotate-180" />
                  </ButtonIconos>
                </TooltipLogBlock>
              </Link>
            </>
          )}

          {/* 🔵 PROFESIONAL */}
          {isProfesional && (
            <>
              <Link to="/contratosFacturas" onClick={onClose}>
                <TooltipLogBlock label="Facturas" place="left">
                  <ButtonIconos>
                    <SvgFactura />
                  </ButtonIconos>
                </TooltipLogBlock>
              </Link>

              <EligeEmpresa />
            </>
          )}

          {/* 🔵 EDITAR USUARIO (TODOS LOGUEADOS REALES) */}
          {(isProfesional || isAfiliado || isUsuario || isAdmin) && (
            <Link to="/editaUsuario" onClick={onClose}>
              <TooltipLogBlock label="Editar usuario" place="left">
                <ButtonIconos>
                  <SvgEditarUsuario />
                </ButtonIconos>
              </TooltipLogBlock>
            </Link>
          )}

          {/* 🔵 PANEL AFILIADO (MULTIROL REAL) */}
          {(isAfiliado || isAdmin || isProfesional) && (
            <Link to="/panelAfiliado" onClick={onClose}>
              <TooltipLogBlock label="Monetización" place="left">
                <ButtonIconos>
                  <SvgGanancias />
                </ButtonIconos>
              </TooltipLogBlock>
            </Link>
          )}

          {/* 🔵 SUSCRIPCIÓN */}
          {canSeeSuscripcion && (
            <Link to="/suscribirse" onClick={onClose}>
              <TooltipLogBlock label="Suscripción" place="left">
                <ButtonIconos>
                  <SvgSuscripcion />
                </ButtonIconos>
              </TooltipLogBlock>
            </Link>
          )}

          {/* 🔴 LOGOUT */}
          <TooltipLogBlock
            label="Salir"
            className="border-red-500 border-2 rounded-md shadow-md shadow-red-500"
          >
            <ButtonIconos onClick={handleLogout}>
              <SvgSalir className="text-red-600" />
            </ButtonIconos>
          </TooltipLogBlock>
        </>
      )}
    </div>
  );
};

export default MobileLogBlock;